import React from 'react';
import { Tabs, Table } from 'antd';
import classNames from 'classnames';
import type { ColumnsType } from 'antd/lib/table';
import { useDispatch } from 'react-redux';
import Relation from '@/business-components/relation';
import ChartHeader from '@/business-components/chart-header';
import Dot from '@/components/Dot';
import UserHead from '@/business-components/userHead';
import { formatNumberValueToChineseUnit } from '@/utils/format';
import CustomEmpty from '@/business-components/CustomEmpty';
import styles from './index.module.scss';
const { TabPane } = Tabs;

export default function FilterBrand({ data, hasUnlock }) {
  const dispatch = useDispatch();
  const viewMore = text => {
    dispatch({
      type: 'modal/open',
      payload: {
        content: (
          <div className={styles.parentDesc}>
            <div className={styles.parentDescContent}>{text}</div>
          </div>
        ),
        title: '母公司简介',
      },
    });
  };
  //注册资本
  const parentRegisterAmount = value => {
    let formatValue;
    if (!isNaN(+value)) {
      formatValue = formatNumberValueToChineseUnit(+value * 1e4, 4);
      return (
        <p>
          <span style={{ fontSize: 16, paddingRight: 2 }}>{formatValue?.value}</span>
          {formatValue?.unit}
        </p>
      );
    } else {
      return '-';
    }
  };
  const columnsCampany: ColumnsType<any> = [
    {
      dataIndex: 'name',
      colSpan: 0,
      // title: '母公司简介',
    },
    {
      className: 'column-money',
      dataIndex: 'money',
      colSpan: 0,
      title: '注册资本',
      // onCell(_, index) {
      //   if (index % 2 == 0) {
      //     return {
      //       align: 'right',
      //     };
      //   }
      // },
      render(_text, _, i) {
        const isMore = _text?.length < 100;
        if (i % 2 === 1) {
          return !_text ? (
            <span className={styles.emptyStateText} style={{ lineHeight: '200px' }}>
              暂无数据
            </span>
          ) : (
            <div className={styles.comIntro}>
              <div style={{ width: 195 }}>
                <div className={`${isMore ? styles.describeContentMore : styles.describeContent}`}>{_text}</div>

                {!isMore && (
                  <div className={styles.more}>
                    <span onClick={() => viewMore(_text)}>显示更多</span>
                  </div>
                )}
              </div>
            </div>
          );
        } else {
          return parentRegisterAmount(_text);
        }
      },
    },
  ];
  const columnsTeam: ColumnsType<any> = [
    {
      dataIndex: 'name',
      render: (_, record) => (
        <UserHead avatarUrl={record?.avatarUrl} memberName={record?.memberName} memberJob={record?.memberJob} />
      ),
      colSpan: 0,
    },
    {
      dataIndex: 'memberDesc',
      colSpan: 0,
      render: (_, record) => (
        <p style={{ maxHeight: 200, overflowY: 'scroll', width: 130, fontSize: 13 }}>{record.memberDesc || '-'}</p>
      ),
    },
  ];

  return (
    <>
      <ChartHeader title="组织能力" titleFontSize={18} className={styles.header} />
      <div className={classNames('flex-row-wrap', 'flex-start-center', styles.organize)}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="所属公司信息" key="1">
            <div className={classNames(styles.content)}>
              {data?.organStrength?.map((item, index) => (
                <Table
                  key={index}
                  columns={columnsCampany}
                  dataSource={[
                    { name: '注册资本', money: item?.parentRegisterAmount },
                    { name: '母公司简介', money: item?.parentCompanyDesc },
                  ]}
                  bordered
                  title={() => (
                    <span className={classNames('flex-row-wrap', 'flex-start-center')}>
                      <Dot className={styles.headerDot} />
                      <span className={styles.name}>{item?.chName}</span>
                    </span>
                  )}
                  className={styles.tabTable}
                  pagination={false}
                />
              ))}
            </div>
          </TabPane>
          <TabPane tab="核心团队信息" key="2">
            {!hasUnlock ? (
              <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
            ) : (
              <div className={classNames('flex-row-wrap', 'flex-start-start', styles.content)}>
                {data?.organCompetencies?.map((item, index) => (
                  <Table
                    key={index}
                    columns={columnsTeam}
                    dataSource={item?.list || []}
                    bordered
                    title={() => (
                      <span className={classNames('flex-row-wrap', 'flex-start-center')}>
                        <Dot className={styles.headerDot} />
                        <span className={styles.name}>{item?.chName}</span>
                      </span>
                    )}
                    pagination={false}
                    className={styles.tabTable}
                  />
                ))}
              </div>
            )}
          </TabPane>
          <TabPane tab="母公司旗下品牌（已收录）" key="3">
            <div className={classNames('flex-row-wrap', 'flex-start-center', styles.content)}>
              {data?.organPenetrate?.map((item, index) => (
                <Relation data={item || []} key={index} num={2} />
              ))}
            </div>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}
